import axios from "../axios";

const END_POINT = "/receptions/calling-doctors";

const addReceptionCallingDoctor = (receptionId,payload) => axios.post(`${END_POINT}/${receptionId}`, payload);
const updateReceptionCallingDoctor = (receptionId,payload) => axios.patch(`${END_POINT}/${receptionId}`, payload);
const getReceptionCallingDoctor = (receptionId) => axios.get(`${END_POINT}/${receptionId}`);
const deleteReceptionCallingDoctor = (receptionId,payload) => axios.delete(`${END_POINT}/${receptionId}`, {data:payload});

export {
    addReceptionCallingDoctor,
    getReceptionCallingDoctor,
    updateReceptionCallingDoctor,
    deleteReceptionCallingDoctor
}